import React, {ChangeEvent, DragEvent, useEffect, useRef, useState} from "react";
import {isMyDesignDetailImageUpload} from "../../const/MyDesignDetailTypeConst.ts";
import {Image} from "react-bootstrap";
import {url} from "../../utils/UrlsUtil.ts";

interface MyDesignImageUploaderProps {
    dto?: DesignTemplateDetailDto;
    add_class_name?: string;
}
const MyDesignImageFile: React.FC<MyDesignImageUploaderProps> = ({
    dto = undefined,
    add_class_name = "",
                                                                     }) => {
    const [image, setImage] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        clear();
    }, [dto]);
    const handleFileChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const file = event.target.files?.[0];
        if(file){
            validateAndSetImage(file);
        }
    };

    const handleDragOver = (event: DragEvent<HTMLDivElement>): void => {
        event.preventDefault();
    };

    const handleDrop = (event: DragEvent<HTMLDivElement>): void => {
        event.preventDefault();
        const file = event.dataTransfer.files?.[0];
        validateAndSetImage(file);
    };
    const validateAndSetImage = (file: File | undefined): void => {
        setImage(null);
        if (!file) {
            console.log("画像ファイルを選択してください");
            if(dto){
                dto.file = null;
            }
            return;
        }

        if (!file.type.startsWith('image/')) {
            console.log("画像ファイルを選択してください");
            if (dto) {
                dto.file = null;
            }
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const img = new window.Image();
            img.src = reader.result as string;

            img.onload = () => {
                setImage(reader.result as string);
                if (dto) {
                    dto.file = file;
                }
            };
            img.onerror = () => {
                console.log("画像ファイルが読み込むことができません。");
                if (dto) {
                    dto.file = null;
                }
            };
        };
        reader.readAsDataURL(file);
    };
    const handleClick = (): void => {
        fileInputRef.current?.click();
    };
    const clear = () => {
        setImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }
    if(isMyDesignDetailImageUpload(dto?.type)){
        return <div className={add_class_name}>
            <label className="my-design-input-title">{dto?.title}</label>
            <div className="my-design-image-uploader"
                 onDragOver={handleDragOver}
                 onDrop={handleDrop}
                 onClick={handleClick}
            >
                <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                />
                {image ? <Image src={image} fluid={true} /> : <Image src={url("/images/icon/image_upload_icon.png")} fluid={true}/>}
            </div>
        </div>;
    }
    return null;
};
export default MyDesignImageFile;
